import { render, staticRenderFns } from "./permissionList.vue?vue&type=template&id=47f260d4&scoped=true&"
import script from "./permissionList.vue?vue&type=script&lang=js&"
export * from "./permissionList.vue?vue&type=script&lang=js&"
import style0 from "./permissionList.vue?vue&type=style&index=0&id=47f260d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f260d4",
  null
  
)

export default component.exports